export default "__VITE_ASSET__DS_XvOFv__"